import React, { Component } from 'react';

import android from '../../img/android.png';
import ios from '../../img/ios.png';
import windows from '../../img/windows.png';
import web from '../../img/web.svg';
import desktop from '../../img/desktop.png';
import linux from '../../img/linux.png';
import react from '../../img/react.svg';
import cordova from '../../img/cordova.svg';
import html5 from '../../img/html5.svg';
import node from '../../img/node.svg';
import unity from '../../img/unity.png';
import electron from '../../img/electron.svg';
import globalizacao from '../escolha/globalizacao';
import git from '../../img/git.svg';
import aws from '../../img/aws.svg';

class HomeTecnologias extends Component {
    render() {
        return (
            <section className="secao tecnologia-utilizada fundo-white">
                <div className="limite conteudo">
                    <h2>{globalizacao.msg("solucoesCross")}</h2>
                    <p>
                       {globalizacao.msg('tecnologiaUsada')}
                    </p>

                    <ul className="lista lista-platform">
                        <li>  <img src={android} alt="android" title="android" /></li>
                        <li> <img src={ios} alt="ios" title="ios"/></li>
                        <li> <img src={windows} alt="windows" title="windows"/></li>
                        <li> <img src={linux} alt="linux" title="linux" /></li>
                        <li> <img src={web} alt="web" title="web" /></li>
                        <li> <img src={desktop} alt="desktop" title="desktop" /></li>
                    </ul>

                    <h2> {globalizacao.msg("tecnologia")} </h2>
                    <p>
                        {globalizacao.msg("tecnologiaEquipe")}
                    </p>
                    <ul className="lista lista-platform">
                        <li>  <img src={react} alt="react" title="react" /></li>
                        <li> <img src={cordova} alt="cordova" title="cordova" /></li>
                        <li> <img src={node} alt="nodejs" title="nodejs" /></li>
                        <li> <img src={html5} alt="html5" title="html5" /></li>
                        <li> <img src={unity} alt="unity" title="unity" /></li>
                        <li> <img src={electron} alt="electron" title="electron" /></li>
                        <li> <img src={git} alt="git" title="git" /></li>
                        <li> <img src={aws} alt="aws" title="Amazon Web Services" /></li>

                    </ul>
                </div>
            </section>

        );
    }
}

export default HomeTecnologias;



// WEBPACK FOOTER //
// ./src/js/pages/home-tecnologias.js